import {Component, input, ChangeDetectionStrategy} from '@angular/core';
import {WaButtonDirective, WaCalloutDirective, WaCardDirective, WaIconDirective, WaToastService} from 'angular-awesome';
import {saveAs} from 'file-saver-es';

import {Survey} from '../../../api/models/survey';
import {SurveyService} from '../../../api/services/survey.service';

@Component({
  selector: 'app-export-panel',
  imports: [WaButtonDirective, WaCalloutDirective, WaCardDirective, WaIconDirective],
  templateUrl: './export-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './export-panel.component.scss'
})
export class ExportPanelComponent {

  readonly survey = input<Survey | null>(null);
  readonly processing = input<boolean>(false);
  readonly optimizationFailed = input<boolean>(false);

  constructor(private readonly surveyService: SurveyService,
              private readonly toastService: WaToastService) {
  }

  canExportAssignments(): boolean {
    const survey = this.survey();
    return !!survey && !this.processing() && survey.has_assignments;
  }

  getPreferencesExport(): void {
    const survey = this.survey();
    if (!survey) return;

    this.surveyService.getPreferencesExport(survey.id).subscribe({
      next: data => {
        const file = new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        saveAs(file, `export-preferences${this.fileTag()}.xlsx`);
      },
      error: () => {
        this.toastService.danger('Could not fetch preferences export.');
      }
    });
  }

  getAllocExport_2_0(): void {
    const survey = this.survey();
    if (!survey) return;

    this.surveyService.getAllocExport_2_0(survey.id).subscribe({
      next: data => {
        const file = new Blob([data], {type: 'application/json'});
        saveAs(file, `import-protocol_2_0${this.fileTag()}.json`);
      },
      error: () => {
        this.toastService.danger('Could not fetch .json allocation export.');
      }
    });
  }

  getCsv(): void {
    const survey = this.survey();
    if (!survey) return;

    this.surveyService.getCsv(survey.id).subscribe({
      next: data => {
        const file = new Blob([data], {type: 'text/csv'});
        saveAs(file, `export${this.fileTag()}.csv`);
      },
      error: () => {
        this.toastService.danger('Could not fetch .csv allocation export.');
      }
    });
  }

  private fileTag(): string {
    const now = new Date();
    const part = (value: number) => value.toString().padStart(2, '0');
    return `-${now.getFullYear()}-${part(now.getMonth() + 1)}-${part(now.getDate())}-${part(now.getHours())}-${part(now.getMinutes())}-${part(now.getSeconds())}`;
  }
}

